export default __webpack_public_path__ + "static/media/edit-subtitle.0a0f8302.webp";